module.exports = __webpack_public_path__ + "static/pic08-c5b3509d9f2c57125a7ee4fe9e2f2462.png";